import { all } from 'redux-saga/effects'
import cartSaga from 'store/cart/sagas'
import paypalSaga from 'store/paypal/sagas'

export default function* rootSaga() {
  yield all([...cartSaga, ...paypalSaga])
}
